var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4H2V6H0V4Z",
    fill: "url(#paint0_linear_595_297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H2V8H0V6Z",
    fill: "url(#paint1_linear_595_297)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H2V10H0V8Z",
    fill: "url(#paint2_linear_595_297)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H2V12H0V10Z",
    fill: "url(#paint3_linear_595_297)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H2V14H0V12Z",
    fill: "url(#paint4_linear_595_297)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H4V16H2V14Z",
    fill: "url(#paint5_linear_595_297)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H6V18H4V16Z",
    fill: "url(#paint6_linear_595_297)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H8V20H6V18Z",
    fill: "url(#paint7_linear_595_297)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H10V20H8V18Z",
    fill: "url(#paint8_linear_595_297)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10V18Z",
    fill: "url(#paint9_linear_595_297)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H14V18H12V16Z",
    fill: "url(#paint10_linear_595_297)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V16H14V14Z",
    fill: "url(#paint11_linear_595_297)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V4H2V2Z",
    fill: "url(#paint12_linear_595_297)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H6V4H4V2Z",
    fill: "url(#paint13_linear_595_297)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H8V2H6V0Z",
    fill: "url(#paint14_linear_595_297)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H10V2H8V0Z",
    fill: "url(#paint15_linear_595_297)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H12V2H10V0Z",
    fill: "url(#paint16_linear_595_297)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H14V4H12V2Z",
    fill: "url(#paint17_linear_595_297)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H16V4H14V2Z",
    fill: "url(#paint18_linear_595_297)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H18V8H16V6Z",
    fill: "url(#paint19_linear_595_297)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H18V10H16V8Z",
    fill: "url(#paint20_linear_595_297)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10H18V12H16V10Z",
    fill: "url(#paint21_linear_595_297)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H18V14H16V12Z",
    fill: "url(#paint22_linear_595_297)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4V6V8V10V12V14H4V16H6V18H8H10H12V16H14V14H16V12V10V8H14V6H16V4H14H12V2H10H8H6V4H4H2ZM12 10V8H14V10H12ZM10 12H12V10H10V12ZM8 12H10V14H8V12ZM6 10H8V12H6V10ZM6 10V8H4V10H6Z",
    fill: "url(#paint23_linear_595_297)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4H2V6H0V4Z",
    fill: "#A7ACF4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H2V8H0V6Z",
    fill: "#A7ACF4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H2V10H0V8Z",
    fill: "#A7ACF4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H2V12H0V10Z",
    fill: "#A7ACF4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H2V14H0V12Z",
    fill: "#A7ACF4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H4V16H2V14Z",
    fill: "#A7ACF4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H6V18H4V16Z",
    fill: "#A7ACF4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H8V20H6V18Z",
    fill: "#A7ACF4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H10V20H8V18Z",
    fill: "#A7ACF4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10V18Z",
    fill: "#A7ACF4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H14V18H12V16Z",
    fill: "#A7ACF4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V16H14V14Z",
    fill: "#A7ACF4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V4H2V2Z",
    fill: "#A7ACF4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H6V4H4V2Z",
    fill: "#A7ACF4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H8V2H6V0Z",
    fill: "#A7ACF4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H10V2H8V0Z",
    fill: "#A7ACF4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H12V2H10V0Z",
    fill: "#A7ACF4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H14V4H12V2Z",
    fill: "#A7ACF4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H16V4H14V2Z",
    fill: "#A7ACF4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H18V8H16V6Z",
    fill: "#A7ACF4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H18V10H16V8Z",
    fill: "#A7ACF4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10H18V12H16V10Z",
    fill: "#A7ACF4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H18V14H16V12Z",
    fill: "#A7ACF4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4V6V8V10V12V14H4V16H6V18H8H10H12V16H14V14H16V12V10V8H14V6H16V4H14H12V2H10H8H6V4H4H2ZM12 10V8H14V10H12ZM10 12H12V10H10V12ZM8 12H10V14H8V12ZM6 10H8V12H6V10ZM6 10V8H4V10H6Z",
    fill: "#A7ACF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_595_297",
    x1: 16,
    y1: 16,
    x2: -0.500001,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235057,
    stopColor: "#5C5E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.5ed5ef44.svg";
export { ForwardRef as ReactComponent };